import {Component, Input} from '@angular/core';

@Component({
	selector: 'savvy-card',
	templateUrl: './card.component.html',
	styleUrls: ['./card.component.scss']
})
export class CardComponent {
	@Input() selected = false;
	@Input() hoverable = true;
}
